import { GetScriptResponseContainerDTO } from '../../../typings/windreamWebService/Windream.WebService.DynamicWorkspace';
import { IServiceResponse } from '../../ajaxHandler/interfaces/iServiceResponse';
import { GlobalConfig } from '../../config';
import { HttpResourcePointer } from '../../dataProviders';
import { IRequestExecutor } from '../../dataProviders/interfaces/iRequestExecutor';
import { Logger } from '../../logging';
import { GetScriptRequestOptions } from '../models';
import { ServiceAction } from '../serviceAction';

/**
 * Service action to perform a GetContextMenuScript on the windream webservice.
 * 
 * @export
 * @class GetContextMenuScript
 * @extends {ServiceAction}
 */
export class GetContextMenuScript extends ServiceAction {

    /**
     * Creates an instance of GetContextMenuScript.
     *
     * @param {IRequestExecutor} requestExecutor The request executor.
     * @param {GlobalConfig} globalConfig The global configuration.
     * @param {Logger} logger The logger.
     * @memberof GetContextMenuScript
     */
    public constructor(requestExecutor: IRequestExecutor, globalConfig: GlobalConfig, logger: Logger) {
        super(requestExecutor, globalConfig, logger);

        this.name = 'getContextMenuScript';
    }

    /**
     * Gets the script's content as string.
     * Resolves with the server response.
     * Overwrites `do()` method from parent class ServiceAction.
     *
     * @param {getScriptRequestOptions} getScriptRequestOptions The request options.
     * @returns {Promise<GetScriptResponseContainerDTO>} A promise, which will resolve with the server response.
     * @memberof GetContextMenuScript
     */
    public async do(getScriptRequestOptions: GetScriptRequestOptions): Promise<GetScriptResponseContainerDTO> {
        return new Promise<GetScriptResponseContainerDTO>((resolve, reject) => {
            const url = `${this.globalConfig.windreamWebServiceURL}/dynamicworkspace/contextmenu/GetContextMenuScript?scriptName=${getScriptRequestOptions.scriptId}`;
            this.requestExecutor.executeRequest(new HttpResourcePointer('GET', url),
                getScriptRequestOptions.requestOptions)
                .then((response: IServiceResponse<GetScriptResponseContainerDTO>) => {
                    if (!response.data || response.data.HasErrors) {
                        this.logger.error('GetContextMenuScript', 'do', 'Failed to get script content', response);
                        reject(new Error('Failed to get script content'));
                    } else {
                        resolve(response.data);
                    }
                }).catch((err) => {
                    this.logger.error('GetContextMenuScript', 'do', 'Failed to execute request', err);
                    reject(err);
                });
        });
    }
}